(() => {
  const rootPath = window.Shopify?.routes?.root || '/';

  const header = document.querySelector('[data-se-header]');
  const menuButton = header?.querySelector('.se-menu-toggle');
  const mobileMenu = header?.querySelector('.se-mobile-menu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  const countdown = document.querySelector('[data-se-countdown]');
  if (countdown) {
    const duration = Math.max(1, Number(countdown.dataset.hours || 12)) * 60 * 60 * 1000;
    const storageKey = 'sleepeaseOfferEnds';
    let endsAt = Number(sessionStorage.getItem(storageKey));
    if (!endsAt || endsAt <= Date.now()) {
      endsAt = Date.now() + duration;
      sessionStorage.setItem(storageKey, String(endsAt));
    }
    const updateCountdown = () => {
      const remaining = Math.max(0, endsAt - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      const seconds = String(totalSeconds % 60).padStart(2, '0');
      countdown.textContent = `${hours}:${minutes}:${seconds}`;
    };
    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  }

  const gallery = document.querySelector('[data-se-gallery]');
  if (gallery) {
    const images = [...gallery.querySelectorAll('[data-se-gallery-image]')];
    const thumbs = [...gallery.querySelectorAll('[data-se-gallery-thumb]')];
    let activeIndex = 0;
    const showImage = (index) => {
      activeIndex = (index + images.length) % images.length;
      images.forEach((image, i) => image.classList.toggle('is-active', i === activeIndex));
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === activeIndex);
        thumb.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
      });
      thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(Number(thumb.dataset.seGalleryThumb))));
    gallery.querySelector('[data-se-gallery-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
    gallery.querySelector('[data-se-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));
    let touchStart = 0;
    gallery.querySelector('.se-gallery__stage')?.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    gallery.querySelector('.se-gallery__stage')?.addEventListener('touchend', (event) => {
      const movement = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(movement) > 45) showImage(activeIndex + (movement < 0 ? 1 : -1));
    }, { passive: true });
  }

  document.querySelectorAll('[data-se-accordion]').forEach((accordion) => {
    accordion.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        accordion.querySelectorAll('details').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  });

  const productRoot = document.querySelector('[data-se-product]');
  if (!productRoot) return;
  const variantData = productRoot.querySelector('[data-se-variants]');
  const variants = variantData ? JSON.parse(variantData.textContent) : [];
  const form = productRoot.querySelector('[data-se-product-form]');
  const idInput = form?.querySelector('[data-se-variant-id]');
  const priceNode = productRoot.querySelector('[data-se-price]');
  const compareNode = productRoot.querySelector('[data-se-compare]');
  const savingNode = productRoot.querySelector('[data-se-saving]');
  const totalValueNode = productRoot.querySelector('[data-se-total-value]');
  const batchSavingNode = productRoot.querySelector('[data-se-batch-saving]');
  const buyButton = productRoot.querySelector('[data-se-buy]');
  const buyLabel = productRoot.querySelector('[data-se-buy-label]');
  const errorNode = productRoot.querySelector('[data-se-form-error]');
  const currency = productRoot.dataset.currency || 'USD';

  const money = (cents) => {
    const formatted = window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents, productRoot.dataset.currencyFormat)
      : new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    return formatted.replace(/([.,])00(?=\D*$)/, '');
  };

  const selectedOptions = () => [...form.querySelectorAll('[data-se-option-index]')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
  const updateVariant = () => {
    if (!variants.length || !form) return;
    const options = selectedOptions();
    const variant = options.length
      ? variants.find((item) => item.options.every((option, index) => option === options[index]))
      : variants.find((item) => String(item.id) === String(idInput?.value)) || variants[0];
    if (!variant) {
      buyButton.disabled = true;
      buyLabel.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    priceNode.textContent = money(variant.price);
    const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
    compareNode.textContent = hasCompare ? money(variant.compare_at_price) : '';
    compareNode.classList.toggle('is-hidden', !hasCompare);
    const comparisonValue = hasCompare ? Number(variant.compare_at_price) : Number(variant.price);
    const totalValue = comparisonValue + 9700;
    const totalSaving = totalValue - Number(variant.price);
    if (totalValueNode) totalValueNode.textContent = money(totalValue);
    if (savingNode) {
      savingNode.textContent = `SAVE ${money(totalSaving)}`;
      savingNode.classList.remove('is-hidden');
    }
    if (batchSavingNode) batchSavingNode.textContent = money(totalSaving);
    buyButton.disabled = !variant.available;
    buyLabel.textContent = variant.available ? 'Start Your Transformation' : 'Sold Out';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  form?.querySelectorAll('[data-se-option-index] input').forEach((input) => input.addEventListener('change', updateVariant));
  updateVariant();

  const batch = productRoot.querySelector('[data-se-batch]');
  if (batch) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateAt = (offset) => {
      const value = new Date(today);
      value.setDate(value.getDate() + offset);
      return value;
    };
    const ordinal = (day) => {
      const remainder = day % 100;
      if (remainder >= 11 && remainder <= 13) return `${day}TH`;
      return `${day}${day % 10 === 1 ? 'ST' : day % 10 === 2 ? 'ND' : day % 10 === 3 ? 'RD' : 'TH'}`;
    };
    const batchDate = (date) => `${date.toLocaleDateString('en-US', { month: 'long' }).toUpperCase()} ${ordinal(date.getDate())}`;
    batch.querySelector('[data-se-batch-prev]').textContent = batchDate(dateAt(-9));
    batch.querySelector('[data-se-batch-active]').textContent = batchDate(dateAt(1));
    batch.querySelector('[data-se-batch-next]').textContent = batchDate(dateAt(11));
    batch.querySelector('[data-se-batch-days]').textContent = '1 DAY';
  }

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!idInput?.value || buyButton.disabled) return;
    errorNode.hidden = true;
    buyButton.disabled = true;
    buyButton.setAttribute('aria-busy', 'true');
    buyLabel.textContent = 'Securing your order…';
    try {
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This selection could not be added.');
      window.location.assign(`${rootPath}checkout`);
    } catch (error) {
      errorNode.textContent = error.message || 'Something went wrong. Please try again.';
      errorNode.hidden = false;
      buyButton.disabled = false;
      buyButton.removeAttribute('aria-busy');
      buyLabel.textContent = 'Start Your Transformation';
    }
  });
})();
